// extracted by mini-css-extract-plugin
export var anchor = "V_dW";
export var anchors = "V_dV";
export var document = "V_dZ";
export var documents = "V_dY";
export var heading = "V_G";
export var privacy = "V_dX";
export var section = "V_j";
export var tariff = "V_d1";
export var tariffs = "V_d0";